import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';

import { API_ROOT } from '../../../api/constants';

import { Form, Label, Select, LabelInput } from '../../common/components/form';

import * as authActions from '../../auth/auth.actions';
import * as userActions from '../user.actions';
import * as teamActions from '../../team/team.actions';
import * as channelActions from '../../channel/channel.actions';
import * as regionActions from '../../region/region.actions';
import { UserRoles } from '../user.constants';
import {
  getAllUsers,
  getAllUsersByCurrentUserChannel,
  getCurrentUser,
  getAllUsersGroupedByChannel,
} from '../user.selectors';
import { formatDate } from '../../../utils/date-utils';
import { partial } from '../../common/utils/partial';

import Table from '../../common/components/Table';
import { Localize } from '../../../locale/localization';
import filter from 'lodash/filter';
import TableHeader from '../../common/components/TableHeader';
import { sortTableAndHead } from '../../../utils/content-utils';
import BaseFormContainer from '../../common/components/form/BaseFormContainer';
import UserControl from './UserControl';
import colors from '../../../utils/colors';
import styled from 'styled-components';

const Wrapper = styled.div`
  span {
    color: ${colors.GRAY_LIGHT};
  }
`;

const baseFormData = {
  keyword: '',
  count: 10,
};

const constraints = {};

class UserSearchForm extends BaseFormContainer {
  state = {
    sortedData: [],
    tableHead: [
      { name: 'name', uiName: Localize('name') },
      { name: 'createdAt', uiName: Localize('joined') },
      { name: 'channel.name', uiName: Localize('channel') },
      { name: 'team.name', uiName: Localize('team') },
      { name: 'role', uiName: Localize('rights') },
    ],
    formData: Object.assign({}, baseFormData),
  };

  componentWillMount = () => {
    const { getUsers } = this.props;

    getUsers();
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.initialCount) {
      this.state.formData.count = nextProps.initialCount; // = this.applyFormDataChange({ count: nextProps.initialCount });
    }
    this.updateSortData(nextProps.allUsers);
  }

  getConstraints = () => constraints;

  updateSortData = content => {
    this.setState(
      Object.assign({}, this.state, {
        sortedData: content ? content : [],
      })
    );
  };

  sortTable = headItem => {
    const sorted = sortTableAndHead(headItem, this.state.tableHead, this.state.sortedData);

    this.setState(
      Object.assign({}, this.state, {
        sortedData: sorted.data,
        tableHead: sorted.head,
      })
    );
  };

  onUserControl = (id, entity) => {
    const registrationLink = `${API_ROOT}register/${entity.emailToken}`;
    this.setState({
      userControllerDialog: true,
      userControllerEntity: {
        id: id,
        entity: entity,
        registrationLink,
      },
    });
  };

  cancelUserControl = event => {
    this.setState({
      userControllerDialog: false,
      // userControllerEntity: null, // TODO: Causes: Uncaught TypeError: Cannot read property 'entity' of null
    });
  };

  renderTableHeader = () => {
    const { currentUser } = this.props;
    let items = this.state.tableHead;

    // filter away channel from all but SUPERUSER
    if (currentUser.role !== UserRoles.SUPERUSER) {
      items = filter(items, function(item) {
        return item.name !== 'channel';
      });
    }

    return <TableHeader items={items} onSort={this.sortTable} sortable={this.state.sortedData.length > 1} />;
  };

  renderUserRow = user => {
    const { currentUser } = this.props;
    const { _id, firstName, lastName, email, createdAt, channel, region, team, role } = user;

    const displayName = firstName && lastName ? `${firstName} ${lastName}` : email;
    const canHasTransactions = user.role === UserRoles.SELLER || user.role === UserRoles.TEAMLEADER;

    let enabledUserControl = true;
    if (user.role === UserRoles.SUPERUSER) {
      enabledUserControl = false;
    } else if (channel && _id === channel.adminUser) {
      enabledUserControl = false;
    } else if (region && _id === region.adminUser) {
      enabledUserControl = false;
    } else if (team && _id === team.adminUser) {
      enabledUserControl = false;
    }

    return (
      <tr key={_id}>
        <td>{displayName}</td>
        <td>{formatDate(createdAt)}</td>
        {currentUser.role === UserRoles.SUPERUSER && <td>{channel && channel.name}</td>}
        <td>{team && team.name}</td>
        <td>{Localize(`user.role.${role}`)}</td>
        <td>
          <div className="action-wrap">
            <Wrapper>
              {canHasTransactions && (
                <NavLink to={`/admin/users/transactions/${_id}`}>Myynnit</NavLink>
                //{Localize('admin.to.users')}
              )}
              &#160;
              {enabledUserControl ? (
                <a onClick={partial(this.onUserControl, _id, user)}>Hallinta</a>
              ) : (
                <span>Hallinta</span>
              )}
            </Wrapper>
          </div>
        </td>
      </tr>
    );
  };

  render() {
    const {
      users,
      updateUser,
      updateTeam,
      updateRegion,
      updateChannel,
      deleteUser,
      deleteTeam,
      deleteRegion,
      deleteChannel,
      adminLoginAsUser,
      getTeams,
    } = this.props;

    const { keyword, count } = this.state.formData;
    const allUsers = this.state.sortedData;

    const rule = new RegExp(`\\b${keyword.replace(/[^\w ]/gi, ' ')}`, 'gi');
    const persons = allUsers
      .filter(u => {
        const searchString = [
          u.firstName,
          u.lastName,
          u.email,
          (u.channel && u.channel.name) || '',
          (u.region && u.region.name) || '',
          (u.team && u.team.name) || '',
        ].join(' ');
        return rule.test(searchString);
      })
      .slice(0, count);

    return (
      <Form autoCorrect="off" autoComplete="off" noValidate spellCheck="false">
        <LabelInput
          half
          type="text"
          label={Localize('transaction.search.person')}
          name="keyword"
          value={keyword}
          onChange={this.onInputChange}
        />
        <Label label={Localize('transaction.search.count')} half>
          <Select value={count} name="count" onChange={this.onInputChange}>
            <option id="5" value="5">
              5
            </option>
            <option id="10" value="10">
              10
            </option>
            <option id="15" value="15">
              15
            </option>
            <option id="25" value="25">
              25
            </option>
            <option id="50" value="50">
              50
            </option>
          </Select>
        </Label>
        {persons && persons.length > 0 ? (
          <Table items={persons} renderHeader={this.renderTableHeader} renderItem={this.renderUserRow} />
        ) : (
          <p>{Localize('user.empty')}</p>
        )}
        <UserControl
          open={this.state.userControllerDialog}
          onCancel={this.cancelUserControl}
          onConfirm={this.cancelUserControl}
          user={this.state.userControllerEntity}
          users={users}
          updateUser={updateUser}
          updateTeam={updateTeam}
          updateRegion={updateRegion}
          updateChannel={updateChannel}
          deleteUser={deleteUser}
          deleteTeam={deleteTeam}
          deleteRegion={deleteRegion}
          deleteChannel={deleteChannel}
          adminLoginAsUser={adminLoginAsUser}
          getTeams={getTeams}
        >
          <p>{Localize('form.no.cancel')}</p>
        </UserControl>
      </Form>
    );
  }
}

const mapStateToProps = (state, { initialCount }) => {
  const currentUser = getCurrentUser(state);
  const allUsers =
    currentUser.role === UserRoles.SUPERUSER ? getAllUsers(state) : getAllUsersByCurrentUserChannel(state);
  const users = getAllUsersGroupedByChannel(state);
  return {
    allUsers,
    currentUser,
    initialCount,
    users,
  };
};

const ConnectedUserSearchForm = connect(
  mapStateToProps,
  Object.assign({}, userActions, teamActions, channelActions, regionActions, authActions)
)(UserSearchForm);

export default ConnectedUserSearchForm;



// WEBPACK FOOTER //
// ./src/modules/user/components/UserSearchForm.js